import styled from "styled-components";
import { Type } from 'theme/types';
import { Title } from "theme/theme";

export const TitlePassword = styled(Title)`
  ${({ theme }: Type) => theme?.password?.text?.title}
`